import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BottomBar from './components/BottomBar';
import Footer from './components/Footer';
import Header from './components/Header';
import { HelpProvider } from './components/HelpDialog';
import { useEscapeQuickExit } from './components/QuickExit';
import ScrollManager from './components/ScrollManager';
import SosStrip from './components/SosStrip';
import Comments from './pages/Comments';
import DeleteAccount from './pages/DeleteAccount';
import Help from './pages/Help';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import Privacy from './pages/Privacy';
import Update from './pages/Update';

// Loaded only on this page, so the Supabase library does not weigh on the home page.
const ResetPassword = lazy(() => import('./pages/ResetPassword'));

const Shell: React.FC = () => {
  useEscapeQuickExit();

  return (
    <div className="app-shell">
      <a href="#contenido" className="skip">
        Saltar al contenido
      </a>
      <SosStrip />
      <Header />
      <main id="contenido" tabIndex={-1} data-inert-when-menu>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/ayuda" element={<Help />} />
          <Route path="/politica-de-privacidad" element={<Privacy />} />
          <Route path="/comentarios" element={<Comments />} />
          <Route path="/eliminar-cuenta" element={<DeleteAccount />} />
          <Route path="/actualizar" element={<Update mode="actualizar" />} />
          <Route path="/descargar" element={<Update mode="descargar" />} />
          <Route
            path="/restablecer"
            element={
              <Suspense fallback={null}>
                <ResetPassword />
              </Suspense>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <BottomBar />
    </div>
  );
};

function App() {
  return (
    <Router>
      <HelpProvider>
        <ScrollManager />
        <Shell />
      </HelpProvider>
    </Router>
  );
}

export default App;
